<template>
  <v-row no-gutters>
    <v-col>
      <!-- tool bar -->
      <v-card
          color="grey lighten-4"
          flat
          style="margin-bottom: 6px;"
          tile
      >
        <v-app-bar
          dense
          fixed
          color="elevation-1"
          style="margin-top:70px;"
        >
          <v-row no-gutters>
            <v-col class="d-flex pa-0">
              <v-autocomplete
                v-model="location_selected"
                :items="locations_list"
                item-text="name"
                item-value="_guid"
                label="All locations"
                dense
                solo
                clearable
                hide-details
                style="max-width:340px"
              >
                <template
                  slot="selection"
                  slot-scope="data"
                >
                  <div>
                    <div v-html="data.item.name" />
                  </div>
                </template>
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <!-- Divider and Header-->
                  <!-- Area item (group) -->
                  <template v-if="data.item._guid.type == TYPE_AREA">
                    <div class="select-drop-item-group__area">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                  <!-- Restaurant item (sub group) -->
                  <template v-else>
                    <div class="select-drop-item-sub_restaurant">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                </template>
              </v-autocomplete>

              <div style="margin-left:16px">
                <v-btn @click="onPreviosRange">
                  <v-icon>mdi-menu-left</v-icon>
                </v-btn>

                <v-menu
                  v-model="menu_date_picker"
                  transition="scale-transition"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on">
                      {{dateRangeText(date_range_selected)}}
                    </v-btn>
                  </template>

                  <v-card max-width="346px">
                    <v-date-picker
                      v-model="date_range_selected"
                      scrollable
                      actions
                      full-width
                      first-day-of-week="1"
                      range
                      :title-date-format="dateRangeText"
                      v-on:click:date="dateRangeSelect"
                    ></v-date-picker>

                    <v-divider></v-divider>

                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn text @click="menu_date_picker = false">Cancel</v-btn>
                      <v-btn color="primary" text @click="menu_date_picker = false">Save</v-btn>
                    </v-card-actions> -->
                  </v-card>
                </v-menu>

                <v-btn @click="onNextRange">
                  <v-icon>mdi-menu-right</v-icon>
                </v-btn>
              </div>

              <v-select
                v-model="interval_selected_id"
                :items="interval_list"
                item-text="name"
                item-value="id"
                @change="onSelectInterval"
                dense
                solo
                hide-details
                style="max-width:150px; margin-left:16px;"
              ></v-select>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>

          <div>
            <request-invoice-modal
              :periodDateFrom="date_range_selected && date_range_selected[0]"
              :periodDateTo="date_range_selected && date_range_selected[1]"
              :restaurantId="location_selected && location_selected.type == TYPE_RESTAURANT ? location_selected.id : void 0"
              :driverId="void 0"
              :disabled="!date_range_selected || !location_selected || location_selected.type != TYPE_RESTAURANT"
              :comission="invoice_comission"
              @invoiceGenerated="dateRangeSelect"
            ></request-invoice-modal>
          </div>
        </v-app-bar>
      </v-card>
      <!--/ tool bar -->
      <!-- body -->
      <div
        class="d-flex mb-auto"
        flat
        tile
      >
        <!-- right panel work area -->
        <v-card
          color="elevation-0"
          class="panel-invoices"
        >
          <v-card
            color="elevation-1"
            width="100%"
            class="time-sheet-table"
            style="margin-bottom:3px;"
            tile
          >
            <!-- headers -->
            <v-card
              color="elevation-1"
              class="time-sheet-table__header"
              style="margin-bottom:2px;"
              tile
            >
              <v-row no-gutters>
                <v-col  sm="2" >Period</v-col>
                <v-col  sm="1" >Invoice Reference</v-col>
                <v-col sm="1">Amount</v-col>
                <v-col  sm="2" @click="sortLocationAsc = !sortLocationAsc" >Location <v-icon small>{{ sortLocationAsc ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon></v-col>
                <v-col sm="1">Status</v-col>
              </v-row>
            </v-card>
            <!--/ headers -->
            <!-- body -->
            <v-card
              color="elevation-1"
              style="border-bottom: 1px solid #9ea2a9; padding-bottom: 3px;margin-bottom: 1px;"
              no-gutters
              tile
              class="time-sheet-table__line"
              v-for="item in invoicesSeached"
              :key="item.id"
             >
              <v-row align="center">
                <v-col  sm="2">{{ moment(item.period_date_from).format("DD/MM") }} to {{ moment(item.period_date_to).format("DD/MM/YYYY") }}</v-col>
                <v-col  sm="1"><a v-if="item.freeagent_invoice && item.freeagent_invoice.reference" :href="config.freeagent_base_url + 'invoices/' + item.invoice_number"target="_blank" style="text-decoration: none; color: inherit;">{{ item.freeagent_invoice.reference }}</a></v-col>
                <v-col sm="1">£{{ item.freeagent_invoice ? parseFloat(item.freeagent_invoice.total_value || 0).toFixed(2) : '0.00' }}</v-col>
                <v-col  sm="2">{{getRestaurantNameByID(item.restaurant_id)}}, {{getAreaLabel(item.restaurant_id)}}</v-col>
                <v-col sm="1"><span v-if="item" class="invoice-status" :class="{'status-paid': item.payment_status === 1,'status-pending': item.payment_status === 0}"@click="item.payment_status === 0 && confirmMarkPaid(item)">{{ item.payment_status === 1 ? 'Paid' : 'Pending' }}</span><v-btn v-if="item.payment_status === 0" title="Refresh" icon small:loading="refreshingInvoiceId === item.id"@click="refreshInvoice(item.invoice_number)" color="black"><v-icon medium color="blue">mdi-refresh</v-icon></v-btn>
                </v-col>
                <v-col  sm="5" class="text-left" >
                  <div v-if="item" class="d-flex justify-start" style="gap: 8px; flex-wrap: wrap;">
                  <v-btn small  color="green" :disabled="(item.payment_status === 1 || localLoading)" :loading="localLoading" @click=" onPayInvoiceConfirm(item)"><v-icon>mdi-credit-card</v-icon>&nbsp
                    Pay Now
                  </v-btn>
                
                  <v-btn small v-on:click="onViewInvoice(item)" :loading="localLoading">
                    <v-icon>mdi-file-eye</v-icon>&nbsp;View
                  </v-btn>
                  <v-btn small v-on:click="onDownloadInvoice(item)" :loading="localLoading" class="ml-2">
                    <v-icon>mdi-file-download</v-icon>&nbsp;Download
                  </v-btn>
                  <v-btn small :disabled="item.mark_as_paid === 1" @click="markAsPaid(item)" :loading="localLoading" class="ml-2">
                    <v-icon>mdi-file-check</v-icon>&nbsp;Mark as Paid
                  </v-btn>
                  <v-btn small
                    class="red darken-4 ml-2"
                    :disabled="localLoading"
                    :loading="localLoading"
                    @click="onRemoveInvoice(item)">
                  <v-icon>mdi-close-circle</v-icon>&nbsp;Remove
                </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
            <!--/ body -->
          </v-card>
          <!--/ right panel work area -->

        </v-card>
      </div>
      <!--/ body -->
    </v-col>
      <v-snackbar v-model="showSnackbar" :timeout="3000" :color="snackbarColor" transition="slide-y-transition" top right class="payment-snackbar" :multi-line="true">
        <div class="d-flex align-center">
          <v-icon :color="snackbarColor ==='green' ? 'white' : 'white'" class="mr-2">
            {{ snackbarColor === 'green' ? 'mdi-check-circle' : 'mdi-alert-circle' }}
          </v-icon>
        <span class="snackbar-text">{{ successMessage }}</span>
        </div>
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="showSnackbar = false" small>
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </template> 
      </v-snackbar>
  </v-row>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';
import * as _ from 'lodash';
import config from '@/configs/config';
import { mapGetters } from 'vuex';
import { TYPE_AREA, TYPE_RESTAURANT } from '../../store/areas';
import { DATE_RANGE_HELPERS,
         INTERVAL_DAY, INTERVAL_WEEK, INTERVAL_TWO_WEEK, INTERVAL_MONTH
       } from '../../store/shifts';

export default {
  name: "Invoices",
  data: () => ({
    // const list for template
    TYPE_AREA: TYPE_AREA,
    TYPE_RESTAURANT: TYPE_RESTAURANT,
    interval_list: [
      { id: INTERVAL_DAY, name: 'Day', $isDisabled: true },
      { id: INTERVAL_WEEK, name: 'Week' },
      { id: INTERVAL_TWO_WEEK, name: '2-Week' },
      { id: INTERVAL_MONTH, name: 'Month' },
    ],
    // ---
    localLoading: false,
    config,
    date_range_selected: null,
    period_date_selected: null,
    successMessage: '',
    sortLocationAsc: true,
    showSnackbar: false,
    snackbarColor: 'green',
    showPayTooltip: false,
    paymentProcessing: false,
    menu_date_picker: false,
    location_selected: void 0,
    interval_selected_id: INTERVAL_WEEK, // default week
    invoice_comission_default: void 0,
    invoice_comission: void 0,
    mark_as_paid: false,
  }),
  computed: {
    ...mapGetters({
      locations_list: 'locations',
      area_list: 'areas',
      restaurant_list: 'restaurants',
      invoices_list: 'invoices',
      options: 'options',
    }), 
    restaurantListSearched() {
      if (!this.$data.location_selected) {
        return this.restaurant_list;
      }

      if (this.$data.location_selected.type == TYPE_AREA) {
        // filter by list of restaurants
        return _.filter(this.restaurant_list, p => p.area_id == this.$data.location_selected.id);
      } else if (this.$data.location_selected.type == TYPE_RESTAURANT) {
        // filter by one restaurant
        let restaurant = _.find(this.restaurant_list, p => p.id == this.$data.location_selected.id)
        if (restaurant) {
          return [restaurant];
        }
        return [];
      }

      return this.restaurant_list;
    },
    invoicesSeached() {
      let result = this.invoices_list || [];

      if (this.$data.location_selected !== void 0) {
        const restaurant_ids = this.restaurantListSearched.map(p => +p.id); // Ensure restaurant IDs are numbers
        result = result.filter(p => restaurant_ids.includes(+p.restaurant_id)); // Filter by restaurant ID
      }

      result = _.orderBy(result, p => p.period_date_from); // Order invoices by date
      
      return result.sort((a, b) => {
        const locA = this.getRestaurantNameByID(a.restaurant_id) + this.getAreaLabel(a.restaurant_id);
        const locB = this.getRestaurantNameByID(b.restaurant_id) + this.getAreaLabel(b.restaurant_id);

        return this.sortLocationAsc
          ? locA.localeCompare(locB)
          : locB.localeCompare(locA);
      });
    },
  },
  watch: {
    period_date: function(period_date_new) {
      if (this.$data.period_date_selected != period_date_new) {
        this.$data.period_date_selected = period_date_new;
        this.dateRangeSelect();
      }
    },
    location_selected: function(val) {
      this.invoice_comission = this.invoice_comission_default;
      if (val && val.type == TYPE_RESTAURANT) {
        let restaurant = _.find(this.restaurant_list, p => +p.id == +val.id)
        if (restaurant && restaurant.invoice_comission) {
          this.invoice_comission = restaurant.invoice_comission;
        }
      }
    }
  },
  mounted() {
    // moment.locale(['ru', 'en']);
    // aync load data
    Promise.all([
      this.$store.dispatch('fetchLocations'),
      this.$store.dispatch('fetchOptions'), // restaurants_standard_invoice_comission
    ]).then(() => {
      // fill example data
      let current_date = moment();
      // this.$data.interval_selected_id = this.$data.interval_list[1].id; // 1 - one week
      this.$data.date_range_selected = [current_date.startOf('isoWeek').format('YYYY-MM-DD'), null];

      // setup default comission
      let invoice_comission_default = _.find(this.options, p => p.okey == 'restaurants_standard_invoice_comission');
      if (invoice_comission_default && invoice_comission_default.ovalue) {
          this.invoice_comission_default = invoice_comission_default.ovalue;
      }
      this.dateRangeSelect();
    });
  },
  methods: {
    moment,
    onPayInvoice(item) {
      if (!item || item.payment_status !== 0 || !item.freeagent_invoice || !item.freeagent_invoice.reference || !item.freeagent_invoice.total_value) {
        console.warn('Invalid item or invoice not open:', item);
        return;
      }

      this.localLoading = true;
      this.paymentProcessing = true;
      this.showSnackbarMessage('Processing payment...', 'blue');

      this.$store.dispatch('payInvoiceNow', {
        invoice_number: item.invoice_number,
        stripe_customer_id: item.stripe_customer_id,
        amount:item.freeagent_invoice.total_value,
        freeagent_invoice_reference:item.freeagent_invoice.reference
      })
      .then(res => {
      this.successMessage = res.message;
      this.snackbarColor = res.success ? 'green' : 'red';
      this.showSnackbar = true;
      setTimeout(() => {
        if (res.success) {
          this.dateRangeSelect(); // reload only on success
        }
      }, 3000);
    })
      .catch(error => {
        this.successMessage = res.message;
        this.snackbarColor = 'red';
        this.showSnackbar = true;
      })
      .finally(() => {
        this.localLoading = false;
      });
    },
    onPayInvoiceConfirm(item) {
      if (!window.confirm('Are you sure you want to pay this invoice?')) return
      this.onPayInvoice(item)
    },
    confirmMarkPaid(item) {
        if (!confirm('Change invoice status to Paid?')) return
        this.localLoading = true
        this.$store.dispatch('updateInvoiceStatus', {
            invoice_id: item.id
        })
        .then(res => {
            this.successMessage = res.message
            this.snackbarColor = 'green'
            this.showSnackbar = true
            this.dateRangeSelect() // reload list
        })
        .catch(() => {
            this.successMessage = 'Failed to update invoice status'
            this.snackbarColor = 'red'
            this.showSnackbar = true
        })
        .finally(() => {
            this.localLoading = false
        })
    },
    async refreshInvoice(invoice_number) {
      try {
        const response = await this.$store.dispatch('refreshInvoice',invoice_number);
        if (response.refreshed === false) {
          this.showSnackbarMessage('FreeAgent unavailable. Showing cached invoice.','orange');
        } else {
          this.showSnackbarMessage(
            'Invoice refreshed successfully',
            'green'
          );
        }

      } catch (e) {
        const message =
          (e && e.message) ||
          (e.response && e.response.data && e.response.data.error) ||
          'Failed to refresh invoice cache';

        this.showSnackbarMessage(message, 'red');
      }
    },
    showSnackbarMessage(message, color = 'green') {
      this.successMessage = message;
      this.snackbarColor = color;
      this.showSnackbar = true;
    },
    dateRangeSelect: async function() {
      this.$data.date_range_selected = this.dayToRange(this.$data.date_range_selected[0], this.$data.interval_selected_id);

      // fetch shifts from server
      await Promise.all([
        this.$store.dispatch('fetchInvoices', {
          period_date_from: this.$data.date_range_selected[0],
          period_date_to: this.$data.date_range_selected[1],
          // with_timesheet: '1'
        }),     
      ]);
    },
    onSelectInterval: function() {
      if (this.$data.interval_selected_id == INTERVAL_WEEK || this.$data.interval_selected_id == INTERVAL_TWO_WEEK || this.$data.interval_selected_id == INTERVAL_MONTH) { // reset to the start of week, if changed from day
        let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        this.$data.date_range_selected = [date_to_shift.startOf('isoWeek').format("YYYY-MM-DD"), null];
      }

      if (this.$data.interval_selected_id == INTERVAL_DAY) { // reset to the current day, if changed from week
        let current_day = moment();
        // let date_to_shift_start = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        // let date_to_shift_end = moment(this.$data.date_range_selected[1], "YYYY-MM-DD");
        // if (date_to_shift_start < current_day && current_day < date_to_shift_end) {
          this.$data.date_range_selected = [current_day.format("YYYY-MM-DD"), null];
        // } else {
        //   this.$data.date_range_selected = [date_to_shift_start.format("YYYY-MM-DD"), null];
        // }
      }

      Vue.nextTick(() => {
        this.dateRangeSelect();
      });
    },
    onPreviosRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.subtract(1, 'day');
          break;
        case INTERVAL_WEEK:
          date_to_shift.subtract(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.subtract(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.subtract(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    onNextRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.add(1, 'days');
          break;
        case INTERVAL_WEEK:
          date_to_shift.add(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.add(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.add(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    getAreaLabel: function(restaurant_id) {
      let restaurant = _.find(this.restaurant_list, p => +p.id == +restaurant_id);
      if (!restaurant) {
        return '-'; // impossible
      }

      let area = _.find(this.area_list, p => +p.id == +restaurant.area_id);
      if (!area) {
        return '-'; // impossible
      }

      return area.name;
    },
    // -- helpers:
    dayToRange: function(date, interval_id) {
        return DATE_RANGE_HELPERS.dayToRange(date, interval_id)
    },
    dateRangeText: function (date_range_selected) {
        return DATE_RANGE_HELPERS.dateRangeText(date_range_selected)
    },
    getPeriodDateText: function (period_date_selected) {
      return moment(period_date_selected, "YYYY-MM-DD").format('DD/MM/YYYY');
    },
    getRestaurantNameByID: function(restaurant_id) {
      let resturant = _.find(this.restaurant_list, p => +restaurant_id == +p.id);
      if (!resturant) {
        return '-';
      }

      return resturant.name;
    },
    markAsPaid: function(item) {
      this.localLoading = true;
      this.$store.dispatch('markAsPaid', {
        invoice_id: item.id,
        invoice_number: item.invoice_number,
        mark_as_paid: item.mark_as_paid,
      }).then(() => {
          this.$set(item, 'mark_as_paid', 1)
          this.dateRangeSelect();
          console.log("success", response);
        })
        .catch(() => {
          console.log("Failed, please try again");
        })
        .finally(() => {
          this.localLoading = false;
        });
    },
    onDownloadInvoice: function(invoice) {
      this.localLoading = true;
      this.$store.dispatch('downloadInvoice', {
          //id: invoice.id,
          invoice_number: invoice.invoice_number,
          mark_as_paid: invoice.mark_as_paid,
         //period_date_from: invoice.period_date_from,
          //period_date_to: invoice.period_date_to
      }).then(() => {
          //
      }).finally(() => {
          this.localLoading = false;
      });
    },
    onViewInvoice: function(invoice) {
      this.localLoading = true;
      this.$store.dispatch('viewInvoice', {
          //id: invoice.id,
          invoice_number: invoice.invoice_number,
          mark_as_paid: invoice.mark_as_paid,
          //period_date_from: invoice.period_date_from,
          //period_date_to: invoice.period_date_to
      }).then(() => {
          //
      }).finally(() => {
          this.localLoading = false;
      });
    },
    onRemoveInvoice: function(invoice) {
      this.localLoading = true;

      this.$store.dispatch('removeInvoice', invoice)
      .then(() => {
        //
      }).catch(error => {
          if(error && error.response && error.response.data && error.response.data.id) {
              alert(error.response.data.id[0]);
          }
      }).finally(() => {
          this.localLoading = false;
      });
    }
  },
  filters: {
    headerDate: function (date) {
      return moment(date, "YYYY-MM-DD").format('DD/MM/YYYY');
    },
  },
}
</script>

<style scoped>
  .menu-date__picker {
    padding-left: 12px;
    margin-top: -22px;
    padding-right: 12px;
  }

  .select-drop-item-group__area {
    background: #e0e0e0;
  }

  .select-drop-item-sub_restaurant {
    padding-left: 16px;
  }

  .menu-interval-changer {
    max-width: 120px; padding-top: 2px;
  }

  .menu-select__area {
    width: 300px;
  }
</style>

<style>
  .payment-snackbar {
    z-index: 10000 !important;
  }

  .payment-snackbar .v-snack__wrapper {
    min-width: 350px;
    max-width: 500px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .snackbar-text {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.4;
    color: white;
  }

  /* Animation for better user experience */
  .payment-snackbar.v-snackbar--active {
    animation: slideInRight 0.3s ease-out;
  }

  @keyframes slideInRight {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  /* Button hover effects */
  .v-btn[color="green"]:hover {
    background-color: #43a047 !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(67, 160, 71, 0.3);
    transition: all 0.2s ease;
  }

  /* Loading state styling */
  .v-btn[color="green"][loading] {
    background-color: #66bb6a !important;
    }
  .panel-invoices {
    width: 100%;
    overflow-x:auto;
    padding-bottom:20px;
    margin-top: 47px;
  }

  /* restore overloaded style */
  .multiselect__content-wrapper > ul.multiselect__content {
    padding-left: 0px;
  }

  .invoice-status {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 13px;
    transition: all 0.2s ease;
  }

  .status-paid {
    color: #2e7d32;
    font-weight: 600;
  }

  .status-pending {
    color: #c62828;
    cursor: pointer;
  }

  .status-pending:hover {
    background: #c62828;
    color: #fff;
    box-shadow: 0 2px 6px rgba(198, 40, 40, 0.3);
  }
</style>
